import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import config from "../config";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles, title} from "../website-utils/meta";
import {connect} from "react-redux";
import {fetchBusinessById} from "../state/actions/business";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";

import BusinessHeader from '../parts/BusinessHeader';
import BusinessEndCallToAction from '../parts/BusinessEndCallToAction';
import Footer from '../parts/Footer';

import iconCheck from '../assets/images/icon-check.png';


export class PricingPage extends React.Component {
  componentDidMount() {
    window.analytics.page("Business", "Pricing");

    // Check if the user is "logged in"
    const businessId = localStorage.getItem('businessId');
    if (businessId) {
      this.props.fetchBusinessById(businessId);
    }
  }

  getStartedClicked = () => {
    if (this.props.business) {
      this.props.history.push('/' + this.props.business.slug);
    } else {
      this.props.history.push(config.routes.businessSignUp);
    }
  };

  render() {
    window.prerenderReady = true;

    const {classes} = this.props;

    return (
      <div className="business home">
        <Helmet>
          {title('SingleShift - Pricing')}
          {metaTitles('SingleShift - Pricing')}
          {metaDescriptions('Book online in seconds and schedule a Pro for whenever you need them in the next day or week.')}
        </Helmet>
        <ScrollToTopOnMount/>

        {/* HERO */}
        <div className={`${classes.hero} hero`}>
          <div className="container">
            <BusinessHeader/>
            <div className="row justify-content-md-center">
              <div className={`${classes.headline} col-md-6 headline text-center`}>
                <p className={`${classes.pageIdentifier} text-uppercase`}>Pricing</p>
                <h1>Pay only if your shift is filled.</h1>
                <p>$10 per shift. No contracts or monthly fees.</p>
                <button onClick={this.getStartedClicked} type="button" className={`${classes.heroBtn} btn btn-primary btn-xlg btn-pointer`}>Get Started</button>
              </div>
            </div>
          </div>
        </div>

        {/* SIMPLE PRICING */}
        <div className={classes.section}>
          <div className="container">
            <div className="row justify-content-center">
              <div className={`${classes.sectionHeader} col-md-6 text-center`}>
                <h2>Simple, transparent pricing</h2>
                <p>No surprises, always know what you're paying.</p>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className={classes.builtForItem}>
                    <img className={classes.builtForItemImage} src={iconCheck}/>
                    <p className={classes.builtforItemCopy}>No setup, monthly, or hidden fees</p>
                  </li>
                  <li className={classes.builtForItem}>
                    <img className={classes.builtForItemImage} src={iconCheck}/>
                    <p className={classes.builtforItemCopy}>Pay only if we fill the shift</p>
                  </li>
                  <li className={classes.builtForItem}>
                    <img className={classes.builtForItemImage} src={iconCheck}/>
                    <p className={classes.builtforItemCopy}>Receive an email invoice for every transaction</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* PAYMENT EXAMPLE */}
        <div className={classes.section}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 text-center">
                <h2 className={classes.alignLeftDesktop}>Payment Example</h2>
                <p className={classes.alignLeftDesktop}>Let’s say you have a shift in a few days that you need help filling. You’re willing to pay $10 per hour for a 6 hour shift.</p>
                <p className={classes.alignLeftDesktop}>When SingleShift fills the shift for you, you pay the Pro $60 ($10 x 6) and SingleShift $10 for a total of $70. The amount will be charged to your credit card and an email of the transaction will be emailed to you.</p>
              </div>
              <div className="col-md-4">
                <div className={classes.paymentTblDiv}>
                  <table className={`${classes.paymentTbl} table`}>
                    <tbody>
                      <tr>
                        <td className={classes.paymentTblCell}>
                          <p className={classes.paymentTblValue}>Wage</p>
                          <p className={`${classes.paymentTblNote} small`}>Set by you</p>
                        </td>
                        <td className={classes.paymentTblCell}>
                          <p className={`${classes.paymentTblValue} text-right`}>$10</p>
                          <p className={`${classes.paymentTblNote} text-right small`}>per hour</p>
                        </td>
                      </tr>
                      <tr>
                        <td className={classes.paymentTblCell}>
                          <p className={classes.paymentTblValue}>Duration</p>
                          <p className={`${classes.paymentTblNote} small`}>Set by you</p>
                        </td>
                        <td className={classes.paymentTblCell}>
                          <p className={`${classes.paymentTblValue} text-right`}>6</p>
                          <p className={`${classes.paymentTblNote} text-right small`}>hours</p>
                        </td>
                      </tr>
                      <tr><td colSpan="2" className={classes.paymentTblDivider}/></tr>
                      <tr>
                        <td className={classes.paymentTblCell}>
                          <p className={classes.paymentTblValue}>Total Wages</p>
                          <p className={classes.paymentTblValue}>SingleShift Fee</p>
                        </td>
                        <td className={classes.paymentTblCell}>
                          <p className={`${classes.paymentTblValue} text-right`}>$60</p>
                          <p className={`${classes.paymentTblValue} text-right`}>$10</p>
                        </td>
                      </tr>
                      <tr><td colSpan="2" className={classes.paymentTblDivider}/></tr>
                      <tr>
                        <td className={classes.paymentTblCell}>
                          <p className={classes.paymentTblValue}>Total Paid</p>
                        </td>
                        <td className={classes.paymentTblCell}>
                          <p className={`${classes.paymentTblValue} text-right`}>$70</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <BusinessEndCallToAction/>

        <Footer/>

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  business: state.business.item,
});

const mapDispatchToProps = (dispatch) => ({
  fetchBusinessById: (id) => dispatch(fetchBusinessById(id)),
});

const styles = (theme) => ({
  hero: {
    backgroundColor: '#004DAA',
  },
  headline: {
    margin: '60px 0',
  },
  heroBtn: {
    marginBottom: '15px',
  },
  pageIdentifier: {
    marginBottom: '10px !important',
    fontSize: '18px !important',
    letterSpacing: '0.75px',
    fontWeight: '800',
  },
  section: {
    padding: '100px 0',
    borderBottom: '1px solid #efefef',
  },
  sectionHeader: {
    paddingBottom: '30px',
  },
  builtForItem: {
    overflow: 'hidden',
  },
  builtForItemImage: {
    float: 'left',
    width: '35px',
  },
  builtforItemCopy: {
    marginLeft: '45px',
  },
  paymentTbl: {
    marginBottom: '0',
  },
  paymentTblDiv: {
    border: '1px solid #cccccc',
    padding: '20px 20px 0',
    borderRadius: '5px',
  },
  paymentTblCell: {
    padding: '0 0 20px !important',
    borderTop: '0 !important',
  },
  paymentTblValue: {
    margin: '0' ,
  },
  paymentTblNote: {
    margin: '0' ,
  },
  paymentTblDivider: {
      padding: '0 0 20px !important',
      borderTop: '1px solid #cccccc !important',
  },
  '@media (min-width: 992px)': {
    alignLeftDesktop: {
        textAlign: 'left',
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PricingPage));



// WEBPACK FOOTER //
// ./src/pages/BusinessPricingPage.js